export default __webpack_public_path__ + "static/media/threeDots-filled.162e8201.svg";